export default __webpack_public_path__ + "static/media/paynes-grey-crop.61b00c3a.jpg";